import React from 'react';
import { useNavigate } from 'react-router-dom';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const SavedPropertiesPreview = ({ savedProperties }) => {
  const navigate = useNavigate();

  if (savedProperties?.length === 0) {
    return (
      <div className="bg-card rounded-lg border border-border p-6">
        <div className="flex items-center justify-between mb-4">
          <h2 className="text-lg font-semibold text-foreground">Saved Properties</h2>
          <Button
            variant="ghost"
            size="sm"
            onClick={() => navigate('/saved-properties')}
            iconName="ArrowRight"
            iconPosition="right"
          >
            View All
          </Button>
        </div>
        <div className="text-center py-8">
          <div className="w-16 h-16 bg-muted rounded-full flex items-center justify-center mx-auto mb-4">
            <Icon name="Heart" size={24} className="text-muted-foreground" />
          </div>
          <p className="text-muted-foreground mb-4">No saved properties yet</p>
          <Button
            variant="outline"
            onClick={() => navigate('/property-search-browse')}
            iconName="Search"
            iconPosition="left"
          >
            Start Searching
          </Button>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-card rounded-lg border border-border p-6">
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-lg font-semibold text-foreground">Saved Properties</h2>
        <Button
          variant="ghost"
          size="sm"
          onClick={() => navigate('/saved-properties')}
          iconName="ArrowRight"
          iconPosition="right"
        >
          View All ({savedProperties?.length})
        </Button>
      </div>
      <div className="space-y-4">
        {savedProperties?.slice(0, 3)?.map((property) => (
          <div key={property?.id} className="flex items-center space-x-4 p-3 rounded-lg hover:bg-muted/50 transition-colors cursor-pointer">
            <div className="w-16 h-16 rounded-lg overflow-hidden flex-shrink-0">
              <Image
                src={property?.images?.[0]}
                alt={property?.title}
                className="w-full h-full object-cover"
              />
            </div>
            <div className="flex-1 min-w-0">
              <h3 className="font-medium text-foreground truncate">{property?.title}</h3>
              <p className="text-sm text-muted-foreground truncate">{property?.location}</p>
              <p className="text-sm font-semibold text-primary">${property?.price?.toLocaleString()}</p>
            </div>
            <div className="flex items-center space-x-2 text-sm text-muted-foreground">
              <div className="flex items-center space-x-1">
                <Icon name="Bed" size={14} />
                <span>{property?.bedrooms}</span>
              </div>
              <div className="flex items-center space-x-1">
                <Icon name="Bath" size={14} />
                <span>{property?.bathrooms}</span>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SavedPropertiesPreview;